// import Marquee3k from 'marquee3000';


//------------------
// Components 
//------------------
// import video from './components/video.js';


var mouse = {
  x: false,
  y: false
};

function page_load(){

  var currentUrl = window.location.href;
  var url = new URL(currentUrl);

  var pathName = url.pathname.replace('/', '');

  if(pathName){
    var sta = document.querySelector('.'+pathName);
  }
  if(sta){
    sta.scrollIntoView();
  }

  var nameOfPractice = document.getElementById('nameOfPractice');

  if(nameOfPractice){
    var website = document.getElementById('website');
    var contactEmail = document.getElementById('contactEmail');
    var dataConsent = document.getElementById('dataConsent');

    nameOfPractice.addEventListener('change', validateCheck);
    website.addEventListener('change', validateCheck);
    contactEmail.addEventListener('change', validateCheck);
    dataConsent.addEventListener('change', validateCheck);

  }

  function validateCheck(){
    var elm = this;
    if(elm.value.length > 0){
      removeClass(elm.parentNode, 'show-error');
    }
    if(elm.type === "checkbox") {
      if(elm.checked){
        removeClass(elm.parentNode.parentNode, 'show-error');
      }
    }
  }


  if( document.getElementById('sign-form')){

    document.getElementById('sign-form').addEventListener('submit', function(evt){

      var validation = true;

      let required = document.querySelectorAll('.required');

      for (let a = 0; a < required.length; a++) {
        var inputWrap = required[a];
        var input = inputWrap.querySelector('input');
       
        if(input.type === 'checkbox'){
          if(!input.checked){
              validation = false;
              addClass(input.parentNode.parentNode, 'show-error');
            }
        }else{
          if(input.value.length < 1){
            validation = false;
            addClass(input.parentNode, 'show-error');
          }
        }
       
      }

      let f_name = document.querySelector('#f_name');
      var important_no = document.querySelectorAll('.important-no-input');

      if(f_name){
        if(f_name.value.length > 0){
          evt.preventDefault();
          window.location.href = '/success';
        }
      }
  
      for (let a = 0; a < important_no.length; a++) {
        const element = important_no[a];
        if(element.value.length > 0){
          evt.preventDefault();
          console.log(element);
          window.location.href = '/success';
        }
      }
      
      
      if(!validation){
        evt.preventDefault();
      }

    })

  }

  function hasClass(ele,cls) {
    return !!ele.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)'));
  }

  function addClass(ele,cls) {
    if (!hasClass(ele,cls)) ele.className += " "+cls;
  }

  function removeClass(ele,cls) {
    if (hasClass(ele,cls)) {
      var reg = new RegExp('(\\s|^)'+cls+'(\\s|$)');
      ele.className=ele.className.replace(reg,' ');
    }
  }
};

window.onload = function(event) {
 page_load();

};


var toggleOpenElms = document.querySelectorAll('.toggle-open');

for (let a = 0; a < toggleOpenElms.length; a++) {

  const element = toggleOpenElms[a];

  element.addEventListener('click', toggleOpen);
  
}
  
function toggleOpen(e){

  this.parentNode.classList.toggle('open');}
  var linkEls = document.querySelectorAll('.content a');
  linkEls.forEach(function(el){el.setAttribute('target','_blank');
  
});

